import { render } from "./france.svg?vue&type=template&id=497f280c"
const script = {}
script.render = render

export default script